export default __webpack_public_path__ + "static/media/30.88b03c1f.gif";